import React from "react";
import { default as MUIToggleButton } from "@mui/material/ToggleButton";
import styled from "styled-components";

const StyledMUIToggleButton = styled(MUIToggleButton)`
  height: 100%;
  min-width: 49px;
  text-transform: none !important;
`;

export const ToggleButton = (props) => {
  return <StyledMUIToggleButton {...props} />;
};
